import React from 'react'
import PropTypes from 'prop-types'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

function FeatureV2({ data }) {
  const { headline, backgroundStyle, images } = data

  let sectionClass = 'feature new'
  if (backgroundStyle === 'Fade') sectionClass += ' feature--no-bg'

  const headlineComp = headline ? <p className="feature__text">{headline}</p> : null

  return (
    <section className={sectionClass}>
      <div className="container__inner">
        {headlineComp}
        <div className="feature__icons-box">
          {images.map((image, index) => {
            const imageComp = <GatsbyImage image={getImage(image.image)} alt={image.altText} />
            return (
              /* eslint-disable react/no-array-index-key */
              <div className="feature__img" key={index}>
                {imageComp}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

FeatureV2.propTypes = {
  data: PropTypes.object.isRequired
}

export default FeatureV2
